import { useLazyLoadIncident, incidentTitle } from './incidentUtility';
import { LiveListItem } from './LiveListItem';

export function IncidentLiveListItem(props) {
  const { item } = props;
  const incident = useLazyLoadIncident(item.id);

  // eslint-disable-next-line react-hooks/immutability
  incident.primary = incidentTitle(incident);
  // eslint-disable-next-line react-hooks/immutability
  incident.secondary = `${incident?.type?.code ?? ''} ${
    incident?.type?.name ?? ''
  }`;

  return (
    <LiveListItem
      type="incidents"
      primaryPath="primary"
      secondaryPath="secondary"
      {...props}
      item={incident}
      hideFollow={!incident.point}
    />
  );
}
